import { render, staticRenderFns } from "./EditRelationship.vue?vue&type=template&id=1ef59371&"
import script from "./EditRelationship.vue?vue&type=script&lang=js&"
export * from "./EditRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports